import { ColorOptions } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'
const statusData = [
  { id: 1, value: 'ACTIVE' },
  { id: 2, value: 'INACTIVE' },
]

export const searchFormData: any = () => [
  {
    key: 'searchForm',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'tid',
            ComponentName: TextInputNew,
            placeholder: 'Search by TID',
            borderColor: '#d1d3e2' as ColorOptions,
            onFocusBorderWidth: 1,
            padding: 8,
            borderRadius: 4,
            fontSize: 12,
            fontFamily: 'jiotype-medium',
            labelFontSize: 12,
          },
          {
            fieldName: 'deviceid',
            ComponentName: TextInputNew,
            placeholder: 'Search by Device Id',
            onFocusBorderWidth: 1,
            padding: 8,
            borderColor: '#d1d3e2' as ColorOptions,
            borderRadius: 4,
            fontSize: 12,
            fontFamily: 'jiotype-medium',
            labelFontSize: 12,
          },
          {
            fieldName: 'status',
            ComponentName: Dropdown,
            minWidth: 150,
            data: statusData,
            title: 'Status',
          },
        ],
      },
    ],
    onSubmit: async (values: any) => {
      return 'search'
    },
    actionTitle: 'Search',
  },
]
